module.exports = __webpack_public_path__ + "static/bianhua-332b6987760e59e26f6873348a74c375.png";